<template>
      <div class="col-sm-12" @click.stop="" style="min-height: 20em">
        <h3 class="editor-header">{{ $t('orders.copy_geometry_title') }}</h3>
        <!-- Task type selection - only in add mode -->
        <span class="title">{{ $t('orders.contract') }}</span>
          {{ contract?.id }}
        <open-contract-filter-multi-select
          :from="(new Date()).toISOString()"
          :pre-selected-contract="contractId"
          :show-only-my-contracts-option="true"
          :show-title="false"
          :show-company="false"
          @contracts-selected="setContracts"
        />
        <!-- Task type selection - only in add mode -->
        <span class="title">
          {{ $t('orders.order') }}
        </span>
        <div class="pl-3 pr-3 pb-2" style="height: 5em; overflow: visible !important;">
          <multiselect
            v-model="selectedExportOrders"
            :options="orderOptions"
            :multiple="true"
            :close-on-select="false"
            label="text"
            track-by="value"
            :use-teleport="true"
            teleport-to="body"
            :searchable="true"
            :max-height="200"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :select-label="$t('common.select')"
            :deselect-label="$t('common.remove_selection')"
            :placeholder="$t('orders.select_order')"
          >
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>
        </div>
      </div>
    <div class="row">
        <div class="col-12">
            <span class="title">
                  {{ $t('orders.delete_after_export') }}
            </span>
            <div class="form-check form-switch ms-2">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="copyOrders"
                    name="copy-orders"
                    v-model="deleteAfterExport"
                    @change="deleteAfterExport = $event.target.checked"
                />
            </div>
            <Transition name="fade">
                <div v-if="deleteAfterExport" class="info-box mt-4 col-12">
                    <i class="bi bi-info-circle me-2" />
                    <span>{{ $t("orders.delete_after_export_hint") }}</span>
                </div>
            </Transition>

        </div>
    </div>
      <div class="col-12 button-container">
        <button class="btn btn-secondary form-button" @click="cancelCopying">
          {{ $t('common.close') }}
        </button>
        <button class="btn btn-success form-button" :disabled="selectedExportOrders.length < 1 || disabled" @click="doCopyOrderGeometry">
          {{ $t('common.copy') }}
        </button>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {orderMixin} from "@/components/mixins/OrderMixin";
import OpenContractFilterMultiSelect from "@/components/contract/OpenContractFilterMultiSelect.vue";

export default {
    name: "OrderGeometryExportModal",
    components: {OpenContractFilterMultiSelect},
    mixins: [restApi, orderMixin],
    props: {
        contractId: {
            type: Number,
            default: null
        },
    },
    data: function () {
        return {
            contractIds: [],
            orderOptions: [],
            selectedExportOrders: [],
            deleteAfterExport: false,
            disabled: false,
            loading: false
        }
    },
    watch: {
        contractIds() {
            this.fetchOrderOptions(this.contractIds)
        }
    },
    mounted() {
        if (this.contractId) {
            this.contractIds = [this.contractId]
        }
    },
    methods: {
        fetchOrderOptions: function (contractIds) {
            this.loading = true
            this.orderOptions = []
            this.$nextTick(() => {
                this.restFetchParams(this.orderUrl, {contract_ids: contractIds}, this.handleOrderOptions)
            })
        },
        handleOrderOptions: function (response) {
            if (response && response.data) {
                response.data.forEach(order => {
                    this.orderOptions.push({
                        value: order.id,
                        text: order.id + ' - ' + this.getOrderStringWithInfo(order)
                    })
                })
            }
            this.loading = false
        },
        setContracts: function (contracts) {
            this.contractIds = []
            contracts.map(contract => {
                this.contractIds.push(contract.id)
            })
        },
        cancelCopying() {
            this.$emit('cancelCopy')
        },
        doCopyOrderGeometry() {
            let orderIds = this.selectedExportOrders.map(item => {
                return item.value
            })
            this.disabled = true
            this.$emit('copyGeometry', orderIds)
        },
        isDeleteSelected() {
            return this.deleteAfterExport
        }
    }
}
</script>
